import PageHeadlineWithFourSteps from '../../components/molecules/headlines/PageHeadlineWithFourSteps'
import FeedbackSuccess from '../../components/atoms/feedbacks/feedback-success'
import SendGiftButtons from '../../components/organism/orders/send-gift-buttons.vue'
import AccountIconWh80 from '../../components/atoms/account_icons/AccountIconWh80'

export default {
  components: {
    PageHeadlineWithFourSteps,
    FeedbackSuccess,
    SendGiftButtons,
    AccountIconWh80
  },
  data() {
    return {
      isShowableSuccess: false,
      successMessage: 'ギフトを送信しました',
      flowLineContents: {
        steps: ['作成', 'プレビュー', '確認', '完了'],
        activeStep: 4
      }
    }
  },
  mounted() {
    this.isShowableSuccess = true
  },
  methods: {
    enterSuccess() {
      setTimeout(() => {
        this.isShowableSuccess = false
      }, 3000)
    },
    onClickBackToTop() {
      window.location.href = '/'
    },
    onClickBackWishList(path) {
      window.location.href = path
    }
  }
}
